
// 创建一个Context
import {createContext} from "react";

export const NavbarContext = createContext({
    isShow: true,
    showNavbar: () => {},
    hideNavbar: () => {},
    setShowNavbar: () => {}
})